<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path
      fill="currentColor"
      d="M.7 3.8c.3-.4.7-.8 1.1-1 .5-.2 1-.4 1.5-.4h17.3c1.1 0 2.1.6 2.7 1.4.4.6.7 1.3.7 2v12.3c0 1.9-1.5 3.4-3.4 3.4H3.4C1.5 21.6 0 20 0 18.2V5.8c0-.7.2-1.4.7-2zm2.8 1l7.6 8.4c.1.1.2.2.4.3.2.1.3.1.5.1s.3 0 .5-.1.3-.2.4-.3l7.6-8.4h-17zm18.1 2.3l-6.9 7.6c-.3.4-.7.7-1.2.9-.5.2-1 .4-1.5.4s-1-.1-1.5-.3c-.5-.2-.9-.5-1.2-.9L2.4 7.1v11c0 .6.5 1 1 1h17.3c.5 0 1-.4 1-1v-11z"
    />
  </svg>
</template>
